import { useEffect, useState } from "react";
import { LoadingStatus } from "../../../../../common/enums/loadingStatus";
import { CustomLinkModel } from "../../../models/customLinkModel";
import { ThemeModel } from "../../../models/themeModel";
import CustomLinkSideNav from "../../navbars/sideNav/customLinkSideNav/customLinkSideNav";
import StyleSideNav from "../../navbars/sideNav/styleSideNav/styleSideNav";
import CreateCampaignTopNav from "../../navbars/topNav/createCampaignTopNav";
import "./createCampaignLayout.scss";

export default function CreateCampaignLayout(props: {
  children?: any;
  pageIndex?: number;
  onClickSave?: () => void;
  saveButtonLoadingStatus?: LoadingStatus;
  theme?: ThemeModel;
  customLink?: CustomLinkModel;
  campaignTitle?: string;
  campaignDescription?: string;
  setTitle?: (e: string) => void;
  setDescription?: (e: string) => void;
  setThemeData?: (e: ThemeModel) => void;
  setCustomLinkData?: (e: CustomLinkModel) => void;
}) {
  const [showStyleSideBar, setShowStyleSideBar] = useState(false);
  const [showCustomLinkSideBar, setShowCustomLinkSideBar] = useState(false);

  return (
    <div className="layout">
      <CreateCampaignTopNav
        index={props.pageIndex}
        description={props.campaignDescription}
        title={props.campaignTitle}
        onTitleChange={(e) => props.setTitle?.(e)}
        onDescriptionChange={(e) => props.setDescription?.(e)}
        onClickStyle={() => {
          setShowStyleSideBar(true);
          setShowCustomLinkSideBar(false);
        }}
        onClickShare={() => {
          setShowCustomLinkSideBar(true);
          setShowStyleSideBar(false);
        }}
        onClickSave={props.onClickSave}
        saveButtonLoadingStatus={props.saveButtonLoadingStatus}
      />
      <div className="content">
        <div className="children-container">
          <div className="campaign-layout-children">{props.children}</div>
        </div>
        {showStyleSideBar && (
          <StyleSideNav
            themeData={props.theme}
            onClickClose={() => setShowStyleSideBar(false)}
            onChange={(e) => props.setThemeData?.(e)}
          />
        )}
        {showCustomLinkSideBar && (
          <CustomLinkSideNav
            customLinkData={props.customLink}
            onClickClose={() => setShowCustomLinkSideBar(false)}
            onChange={(e) => props.setCustomLinkData?.(e)}
          />
        )}
      </div>
    </div>
  );
}
